import React, { useMemo } from "react";
import * as THREE from "three";
import { CSG } from "three-csg-ts";

const GlassWithHole = ({ width, height, position, color, color2, isDouble, thickness, config, combi, almVent }) => {
  const spacing = 0.03;
  const hasBlind = config.hasBlind;
  const holeRadius = 0.12;
  const holeYFromTop = 0.4; // üstten 3cm aşağıya delik konumu

  const createGlassWithHole = (glassColor, zOffset) => {
    const glass = new THREE.Mesh(
      new THREE.BoxGeometry(isDouble ? width-0.08 : width, height - 0.1, thickness),
      new THREE.MeshStandardMaterial({ color: glassColor, transparent: true, opacity: 0.5 })
    );
  
    // Daire şekli oluştur
    const circleShape = new THREE.Shape();
    circleShape.absarc(0, 0, holeRadius, 0, Math.PI * 2, false);
  
    const extrudeSettings = {
      depth: thickness + 0.05,
      bevelEnabled: false,
    };
  
    const holeGeometry = new THREE.ExtrudeGeometry(circleShape, extrudeSettings);
  
    // ✅ Geometriyi yukarı (Y) ve geriye (Z) kaydır
    const holeY = height / 2 - holeYFromTop;
    holeGeometry.translate(0, holeY, -(thickness + 0.05) / 2);
    const hole = new THREE.Mesh(holeGeometry);
    
    if(combi) {
        const result = CSG.subtract(glass, hole);
        result.position.z = zOffset;
        result.position.y = height / 2;
        return result;
    } else {
        const result = glass;
        result.position.z = zOffset;
        result.position.y = height / 2;
        return result;
    }
  };

  const frontGlass = useMemo(() => createGlassWithHole(color, isDouble ? -spacing / 2 : 0), [color, isDouble, height, thickness]);
  const rearGlass = useMemo(() => isDouble ? createGlassWithHole(color2, spacing / 2) : null, [color2, isDouble, height, thickness]);

  // Create the aluminum vent if almVent is true
  const renderAlmVent = useMemo(() => {
    if (!almVent) return null;
  
    const ventWidth = width - (isDouble ? 0.06 : 0);
    const ventHeight = 0.15;
    const ventDepth = isDouble ? thickness * 2 + 0.03 : thickness + 0.002;
    const holeWidth = 0.06;
    const holeHeight = 0.01;
    const rows = 5;
    const cols = 9;
    const spacingX = ventWidth / cols;
    const spacingY = ventHeight / rows;
  
    const holes = [];
  
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        const x = -ventWidth / 2 + spacingX / 2 + col * spacingX;
        const y = -ventHeight / 2 + spacingY / 2 + row * spacingY;
  
        holes.push(
          <mesh key={`hole-${row}-${col}`} position={[x, y, -0.001]}>
            <boxGeometry args={[holeWidth, holeHeight, ventDepth + 0.003]} />
            <meshStandardMaterial color="white" />
          </mesh>
        );
      }
    }
  
    return (
      <group position={[0, height - 0.17, 0]}>
        {/* Ana arka plaka */}
        <mesh>
          <boxGeometry args={[ventWidth, ventHeight, ventDepth]} />
          <meshStandardMaterial color="#1A1A1A" />
        </mesh>
  
        {/* Delikler */}
        {holes}
      </group>
    );
  }, [almVent, width, height, thickness, isDouble]);

  return (
    <group position={position}>
      <primitive object={frontGlass} />
      {isDouble && <primitive object={rearGlass} />}
      {isDouble && hasBlind && (
        <group>
          {Array.from({ length: Math.floor((height - 0.2) / 0.025) }).map((_, i) => {
            const y = 0.1 + i * 0.025;
            if(combi) {
              const holeY = height - holeYFromTop - 0.3;
              if ((y - holeY) > holeRadius + 0.01) return null;
            } 
            return (
              <mesh key={i} position={[0, y, 0]}>
                <boxGeometry args={[width - 0.04, 0.004, 0.002]} />
                <meshStandardMaterial color="#c0c0c0" metalness={0.0} roughness={0.1} />
              </mesh>
            );
          })}
        </group>
      )}
      {renderAlmVent}
    </group>
  );
};

export default GlassWithHole;
